import React from 'react';
import PropTypes from 'prop-types';

import { Modal } from './style';
import Loading from '../Loading';

const SuperLoading = ({ show, message }) => (
  <Modal isOpen={show} backdropClassName="super-modal" id="superModal">
    <Loading />
    <p>{message}</p>
  </Modal>
);

SuperLoading.defaultProps = {
  show: false,
};

SuperLoading.propTypes = {
  message: PropTypes.string.isRequired,
  show: PropTypes.bool,
};

export default SuperLoading;



// WEBPACK FOOTER //
// ./src/components/SuperLoading/index.js